import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Box, Typography } from '@mui/material';
import GlassModal from '../../../../v2/MUI_custom_component/Modal/GlassModal';
import { CustomButton } from '../../../../v2/MUI_custom_component';
import BeneficiarySelectCard from './BeneficiarySelectCard';
import { setGapExistingBeneficiary } from '../reducer/gapBeneficiaryReducer';
import { useNavigate } from 'react-router-dom';

const ExistingBeneficiaryModal = ({ onClose, open, data = [], insuranceData }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedId, setSelectedId] = useState(null);

  const selectedBeneficiary = data?.find((b) => b.id === selectedId);

  return (
    <GlassModal
      open={open}
      onClose={onClose}
      title='Select Existing Beneficiary'
      scrollable={true}
      maxWidth='800px'
      zIndex={2}
    >
      <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
        {data?.map((beneficiary) => (
          <BeneficiarySelectCard
            key={beneficiary.id}
            beneficiary={beneficiary}
            selected={selectedId === beneficiary.id}
            onSelect={() => setSelectedId(beneficiary.id)}
          />
        ))}

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            {selectedBeneficiary && (
              <Typography variant='h2'>
                {selectedBeneficiary.header_title} will be added as beneficiary!
              </Typography>
            )}
            <Typography variant='body1'>
              Are you sure you want to proceed to Nominee addition?
            </Typography>
          </Box>

          <Box sx={{ display: 'flex', gap: 1 }}>
            <CustomButton
              variant='outlined'
              color='primary'
              label='Cancel'
              onClick={onClose}
              sx={{ flex: 1 }}
            />
            <CustomButton
              variant='filled'
              color='primary'
              label='Save'
              disabled={!selectedId}
              onClick={() => {
                dispatch(setGapExistingBeneficiary(selectedBeneficiary));
                navigate('/beneficiary/add-gap-nominee', {
                  state: {
                    insuranceData: insuranceData,
                  },
                });
                onClose();
              }}
              sx={{ flex: 1 }}
            />
          </Box>
        </Box>
      </Box>
    </GlassModal>
  );
};

export default ExistingBeneficiaryModal;
